var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_c('router-link',{attrs:{"to":"/sites"}},[_c('i',{staticClass:"icon-minimal-left tim-icons"})]),_vm._v("\n\t\t\tInserisci cantiere\n\t\t")],1),_c('site-form',{attrs:{"model":_vm.model,"on-submit":_vm.addSiteSubmit,"submit-message":"Crea"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }